import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { Bank, FinancialAccount, BankAccountResponse, LinkBankAccountParams } from '../../models';
import { bankMock } from '../../test/data-mock/bank-account';
import { BackendService } from '../backend/backend.service';
import { environment } from '../../../../environments/environment';
import { CustomHttpParamEncoder, getMaskedAccountNumber } from '../../utils';
import { isEmpty } from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class AggregationService {
  constructor(private backendService: BackendService) {}

  getBanksAccounts(businessAccountId: string): Observable<FinancialAccount[]> {
    let params = new HttpParams({ encoder: new CustomHttpParamEncoder() });

    if (!isEmpty(businessAccountId)) params = params.append('businessAccountId', businessAccountId);

    return this.backendService.get<BankAccountResponse[]>(`${environment.mocketbnkPublicService}/bank-accounts`, { params }).pipe(
      map((response) => {
        return response.map((account) => {
          const { name, maskedAccountNumber, balance, currency, id } = account;
          return {
            displayName: `${name} (${getMaskedAccountNumber(maskedAccountNumber)})`,
            balance,
            currency: currency.currencyCode,
            id,
          };
        });
      }),
      catchError((errorRes) => throwError(() => errorRes)),
    );
  }

  linkBankAccounts(linkData: LinkBankAccountParams) {
    return this.backendService
      .post<void>(`${environment.mocketbnkPublicService}/bank-accounts/link`, linkData)
      .pipe(catchError((errorRes) => throwError(() => errorRes)));
  }

  getMockBanks(): Observable<Bank[]> {
    return of(bankMock);
  }
}
